import { render, staticRenderFns } from "./ProductBundleItems.vue?vue&type=template&id=892a226a"
import script from "./ProductBundleItems.vue?vue&type=script&lang=js"
export * from "./ProductBundleItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports